<div class="container" applyContextClass>
  <div id="progress-page" *ngIf="showProgressBar" style="height: 7px; background-color: white">
    <mat-progress-bar mode="indeterminate" color="secondary"></mat-progress-bar>
  </div>
  <app-header></app-header>
  <div class="container-wrap" applyContextClass>
    <router-outlet></router-outlet>
  </div>
  <app-footer [appShowOnContext]="['Default']"></app-footer>
</div>